import { createContext } from "react";

export const OdeUpdateCommentsModalContext = createContext();
